export const questionMapping = {
  projectDetails: {
    projectStartDate: '1.1a',
    hasProjectEndDate: '1.1b',
    projectEndDate: '1.1c',
    countries: '1.2',
    siteArea: '1.3'
  },
  siteBackground: {
    stakeholders: '2.1',
    managementStatus: '2.2',
    lawStatus: '2.3',
    managementArea: '2.4',
    protectionStatus: '2.5',
    areStakeholdersInvolved: '2.6',
    governmentArrangement: '2.7',
    landTenure: '2.8',
    customaryRights: '2.9'
  },
  restorationAims: {
    ecologicalAims: '3.1',
    socioEconomicAims: '3.2',
    otherAims: '3.3'
  },
  causesOfDecline: {
    lossKnown: '4.1',
    causesOfDecline: '4.2'
  },
  preRestorationAssessment: {
    mangrovesPreviouslyOccured: '5.1',
    mangroveRestorationAttempted: '5.2',
    lastRestorationAttemptYear: '5.2a',
    previousBiophysicalInterventions: '5.2b',
    whyUnsuccessfulRestorationAttempt: '5.2c',
    siteAssessmentBeforeProject: '5.3',
    siteAssessmentType: '5.3a',
    referenceSite: '5.3b',
    lostMangrovesYear: '5.3c',
    naturalRegenerationAtSite: '5.3d',
    mangroveSpeciesPresent: '5.3e',
    speciesComposition: '5.3f',
    physicalMeasurementsTaken: '5.3g',
    pilotTestConducted: '5.4',
    guidanceForSiteRestoration: '5.5'
  },
  siteInterventions: {
    whichStakeholdersInvolved: '6.1',
    biophysicalInterventionsUsed: '6.2',
    biophysicalInterventionDuration: '6.2a',
    mangroveSpeciesUsed: '6.2b',
    mangroveAssociatedSpecies: '6.2c',
    localParticipantTraining: '6.3',
    organizationsProvidingTraining: '6.3a',
    otherActivitiesImplemented: '6.4'
  },
  costs: {
    supportForActivities: '7.1',
    projectInterventionFunding: '7.2',
    projectFunderNames: '7.3',
    costOfProjectActivities: '7.4',
    breakdownOfCost: '7.5',
    percentageSplitOfActivities: '7.5a',
    nonmonetisedContributions: '7.6'
  },
  managementStatusAndEffectiveness: {
    dateOfAssessment: '8.1',
    stakeholderManagement: '8.2',
    stakeholderInfluence: '8.3',
    managementStatusChanges: '8.4',
    currentManagementStatus: '8.4a',
    managementLaws: '8.4b',
    nameOfFormalManagementArea: '8.4c',
    projectStatusChange: '8.5',
    currentProtectionStatus: '8.5a',
    financeForCiteManagement: '8.6',
    sufficientFunds: '8.7',
    resourcesToEnforceRegulations: '8.8',
    equitableSharingOfSiteBenefits: '8.9',
    climateChangeAdaptation: '8.10'
  },
  socioeconomicGovernanceStatusAndOutcomes: {
    dateOfOutcomesAssessment: '9.1',
    changeInGovernance: '9.2',
    currentGovenance: '9.2a',
    changeInTenureArrangement: '9.3',
    currentLandOwnership: '9.3a',
    rightsToLandInLaw: '9.3b',
    socioeconomicOutcomes: '9.4',
    achievementOfSocioeconomicAims: '9.5'
  },
  ecologicalStatusAndOutcomes: {
    dateOfEcologicalMonitoring: '10.1',
    monitoringStartDate: '10.1a',
    monitoringEndDate: '10.1b',
    ecologicalMonitoringStakeholders: '10.2',
    mangroveAreaIncrease: '10.3',
    mangroveAreaBeforeAfter: '10.3a',
    mangroveConditionImprovement: '10.4',
    preAndPostRestorationActivities: '10.4a',
    naturalRegenerationOnSite: '10.5',
    percentageSurvival: '10.6',
    causeOfLowSurvival: '10.6a',
    monitoringIndicators: '10.7',
    achievementOfEcologicalAims: '10.8'
  }
}
